import React from 'react';
import { createBrowserRouter, RouteObject } from 'react-router-dom';
import Layout from './components/organisms/Layout/Layout';
import RequireAuth from './components/RequireAuth/RequireAuth';

const Dashboard = React.lazy(() => import('./pages/Dashboard/Dashboard'));
const CartOnboarding = React.lazy(() => import('./pages/CartOnboarding/CartOnboarding'));
const FilehubOnboarding = React.lazy(() => import('./pages/FilehubOnboarding/FilehubOnboarding'));
const RbacManagement = React.lazy(() => import('./pages/RbacManagement/RbacManagement'));
const FeatureFlags = React.lazy(() => import('./pages/FeatureFlags/FeatureFlags'));
const NotFound = React.lazy(() => import('./pages/NotFound/NotFound'));
const Login = React.lazy(() => import('./pages/Login/Login'));

const appRoutes: RouteObject[] = [
  {
    index: true,
    element: (
      <React.Suspense fallback={null}>
        <Dashboard />
      </React.Suspense>
    ),
  },
  {
    path: 'cart-onboarding',
    element: (
      <React.Suspense fallback={null}>
        <CartOnboarding />
      </React.Suspense>
    ),
  },
  {
    path: 'filehub-onboarding',
    element: (
      <React.Suspense fallback={null}>
        <FilehubOnboarding />
      </React.Suspense>
    ),
  },
  {
    path: 'rbac-management',
    element: (
      <React.Suspense fallback={null}>
        <RbacManagement />
      </React.Suspense>
    ),
  },
  {
    path: 'feature-flags',
    element: (
      <React.Suspense fallback={null}>
        <FeatureFlags />
      </React.Suspense>
    ),
  },
  {
    path: '*',
    element: (
      <React.Suspense fallback={null}>
        <NotFound />
      </React.Suspense>
    ),
  },
];

export const router = createBrowserRouter([
  {
    path: '/login',
    element: (
      <React.Suspense fallback={null}>
        <Login />
      </React.Suspense>
    ),
  },
  {
    path: '/',
    element: (
      <RequireAuth>
        <Layout />
      </RequireAuth>
    ),
    children: appRoutes,
  },
]);
